// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2584":"035ea679","4647":"84c13497"}[chunkId] + ".chunk.css";
};